var map = {
	"./icon-company.svg": "CFm7",
	"./icon-lost_item.svg": "tKi1",
	"./icon-ohter.svg": "cPSE",
	"./icon-pass.svg": "yKR3",
	"./icon-rapit.svg": "DSlh",
	"./icon-sightseeing.svg": "4a5w",
	"./icon-station.svg": "YltU",
	"./icon-ticket.svg": "bcnM",
	"./icon-transfer.svg": "RGRw"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mz+K";